import { render, staticRenderFns } from "./NumericExchangeRate.vue?vue&type=template&id=3823c680&scoped=true&"
import script from "./NumericExchangeRate.vue?vue&type=script&lang=js&"
export * from "./NumericExchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./NumericExchangeRate.vue?vue&type=style&index=0&id=3823c680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823c680",
  null
  
)

export default component.exports